// src/components/SortBar.jsx
import "./styling/filterBar.css";

export default function SortBar({ value, onChange, total }) {
  return (
    <div className="sortBar">
    
      <div className="sortWrapper">
        <label htmlFor="sort-select">Sorteren op:</label>
        <select
          id="sort-select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="recommended">Aanbevolen</option>
          <option value="price_asc">Prijs: oplopend</option>
          <option value="price_desc">Prijs: aflopend</option>
          <option value="name_asc">Naam A–Z</option>
          <option value="name_desc">Naam Z–A</option>
          <option value="newest">Nieuwste</option>
        </select>
      </div>
    </div>
  );
}
